'use client'
import { DialogContent, DialogHeader, DialogTitle } from '../Dialog'
import ModelBlock from '../ModelBlock'
import Image from 'next/image'
import { Dialog } from '@radix-ui/react-dialog'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useStore } from 'web/src/lib/context/store-context'
import { useCart } from 'medusa-react'
import { ProductCategory } from '@medusajs/medusa'
import getModalImage from '../../utils/getModalImage'
import Link from 'next/link'
import routes from 'web/src/lib/routes'

const ModelDialog = ({ startClosed }: { startClosed?: boolean }) => {
    const {
        setContext,
        allCarModels,
        firstTimeUser,
        setFirstTimeUser,
        isModelDialogOpen,
        closeModelDialog,
        openModelDialog,
    } = useStore()
    const { cart } = useCart()

    useEffect(() => {
        if (!startClosed) {
            if (cart?.id) {
                if (!cart?.context?.model && firstTimeUser) {
                    openModelDialog()
                    setFirstTimeUser(false)
                }
            }
        }
    }, [cart])

    const handleModelClick = (model: string) => {
        setContext({ ...cart?.context, model })
        closeModelDialog()
    }

    const carModels = allCarModels.reduce(
        (acc: { oldModels: ProductCategory[]; newModels: ProductCategory[] }, model) => {
            if (getModalImage(model.handle)) {
                acc.newModels.push(model)
            } else {
                acc.oldModels.push(model)
            }
            return acc
        },
        { oldModels: [], newModels: [] },
    )

    return (
        <Dialog
            onOpenChange={() => {
                closeModelDialog()
            }}
            open={isModelDialogOpen}
        >
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Selecteer uw model</DialogTitle>
                </DialogHeader>
                <div className="flex flex-wrap gap-x-8 gap-y-4 [&>*]:w-[calc(50%_-_16px)] md:[&>*]:w-[calc(33.33333%_-_21.33333px)]">
                    {carModels?.newModels?.map((model, index) => {
                        return (
                            <ModelBlock
                                key={model.id}
                                as={'button'}
                                onClick={() => handleModelClick(model.handle)}
                                type="button"
                                title={model.name}
                                image={
                                    <Image
                                        //@ts-ignore
                                        src={getModalImage(model.handle)}
                                        className={'h-full w-full object-cover'}
                                        alt={`Model ${model.name}`}
                                        width={188}
                                        height={72}
                                        loading={index < 6 ? 'eager' : 'lazy'}
                                        priority={index < 6}
                                    />
                                }
                            />
                        )
                    })}
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default ModelDialog
